var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[(_vm.messages)?_c('TheMessage',{attrs:{"text":_vm.message.text,"type":_vm.message.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }